/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Admin.Search <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 13.8.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 13.8.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.AdminSearch", $.common.VisualBase, {

    _create: function () {
        var me = this;
        try {
          
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 318;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {

            me.showMessage("", false);
           
            ////adopt heights and widths
            var h = parseInt(me.visual.height() -
                me.fnd("#div-top-menu").height() -
                me.fnd("#div-filter-menu").height());
            me.fnd(".lst-entries").height(parseInt(h));


        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {

            me.element.on("click", "#div-top-menu .button-toggle", function () {
                me.fnd("#div-top-menu .button-toggle").removeClass("button-toggle-active");
                $(this).addClass("button-toggle-active");
                me._toggleSubmenu();
                me._fetch();
            });
            me.element.on("click", ".btnMainItem", function () { me._fetch() });
            me.fnd("#div-top-menu .button-toggle").button();

            me.fnd("#div-filter-menu #txt-filter-text").vcFilter({ callback: function () {  me._fetch() }});
            me.element.on("keypress", "#div-filter-menu #txt-filter-id", function (e) {
                if (e.which === 13) {
                    me._fetch();
                }
               
            });
            me.element.on("change", ".select-unit, .select-hardwarenames, .select-protocol", function () { me._fetch() });

            ////input validation for input field
            me.fnd(".lst-entries", '.set-logger').click(function (e) {
                var blid = $(e.target).data("blid");
                if (typeof blid !== "undefined") { $("<div>").vcSetLogger({ blid: parseInt(blid) }); }
               
            });
        

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    _fetch: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        var param;
        try {
          
            param = {};
            param.searchType = parseInt(me.fnd("#div-top-menu .button-toggle-active").data("type"));
            param.ID = -1;
            param.Filter = [];
            if (me.fnd("#chk-id").prop("checked")) {
               
                param.ID = me.fnd("#txt-filter-id").val();
                if ($.isNumeric(param.ID)) {
                    param.ID = parseInt(param.ID);
                    param.Blhnid = -1;
                    param.Bluid = -1;
                    param.Blhpid = -1;
                }  else {
                    me.fnd("#txt-filter-id").val("");
                    me.fnd(".lst-entries").html($("<div>").addClass("note").html(me.specific.resources.ERR_noSelection));
                    return false;
                }

            } else {
                param.Blhnid = parseInt(me.fnd("#div-filter-menu .select-hardwarenames").val());
                param.Bluid = parseInt(me.fnd("#div-filter-menu .select-unit").val());
                param.Blhpid = parseInt(me.fnd("#div-filter-menu .select-protocol").val());
                param.Filter = me.fnd("#div-filter-menu #txt-filter-text").vcFilter("getFilter");
              
                if (param.Filter === null && param.Blhnid < 1 && param.Bluid < 1 && param.Blhpid < 1) {
                    me.fnd(".lst-entries").html($("<div>").addClass("note").html(me.specific.resources.ERR_noSelection));
                    return false;
                }
             
            }
          

            me.fnd(".lst-entries").html(me.getLoadingIcon());

            me.getData(param, function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
               }
               
                me._generateList(result);
                return true;
            });

        } catch (e) { me.writeError('_fetch', e); return false;}
        return true;
    },



    _generateList: function (dtt) {
        /// <summary>
        /// This function generates a list from the data and ...
        /// nothing too complicated
        /// </summary>
        var me = this;
        var item, col, col1, col2, col3, col4;
        var list;
        try {

            list = me.fnd(".lst-entries");
            list.html("");

            if (dtt === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
             
            if (dtt.rows === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }
           

            for (var i = 0; i < dtt.rows.length; i++) {
                item = $("<div>", { "class": "vc-list-item" });
         
                if (dtt.rows[i].active ===false) {
                    item.addClass("inactive");
                }

                col3 = $("<div>", { "class": "vc-list-col col3" });
                col3.append($("<div>", { "class": "vc-list-col-element", "html": $("<i>", { 'data-blid': dtt.rows[i].blid, "class": "set-logger fa fa-exchange-alt icon-color-ok" }) }));
                item.append(col3);

                col = $("<div>", { "class": "vc-list-col col0" });
                col.append($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].id }));
                item.append(col);

                col1 = $("<div>", { "class": "vc-list-col col1" });
                col1.append($("<div>", { "class": "vc-list-col-element", "html": me._setIcon(dtt.rows[i].active) + '' +  dtt.rows[i].name }));
                item.append(col1);


                col2 = $("<div>", { "class": "vc-list-col col2" });
                col2.append($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].logger + " (" + dtt.rows[i].blid + ")" }));
                item.append(col2);

                col4 = $("<div>", { "class": "vc-list-col col4" });
                col4.append($("<div>", { "class": "vc-list-col-element", "html": dtt.rows[i].info }));
                item.append(col4);
            
                list.append(item);
            }

            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');

            return true;
        } catch (e) {
            me.writeError('_save', e); return false;
        }

    },

    _setIcon: function (bActive) {
        if (bActive) {
            return "";
        } else {
            return "<i class='fa fa-times icon-color-error'></i> ";
        }
    },

    _toggleSubmenu: function () {
        var me = this;
        var type = parseInt(me.fnd("#div-top-menu .button-toggle-active").data("type"));
       if (type === 0) {
           me.fnd("#div-filter-menu .sub").show();

       }    else {
           me.fnd("#div-filter-menu .sub").hide();
       }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd(".lst-entries, #div-top-menu, #div-filter-menu").hide();
            }
            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    }


});

